import Vue from 'vue'

import { mapMutations, mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  template: `
    <div style="width: 80%; padding-top: 17px;">
      <b-form-select @change="onSelectionChange" v-model="selected" :options="options" size="sm" class="trainingSelector"></b-form-select>
      <p style="color: red; margin: 0;" v-if="isDouble">Дублирование роли в команде</p>
      <p v-else></p>
    </div>
  `,
  data() {
    return {
      selected: [],
      isDouble: false
    }
  },
  created() {
    const { role } = this.params.data
    if (role) {
      this.selected = role
    }
    this.updateTeams({
      team: this.params.data.group,
      role: {
        id: this.params.data.id,
        role: this.params.data.role
      }
    })
  },
  updated() {
    const { role } = this.params.data
    if (role) {
      this.selected = role
    }
  },
  computed: {
    ...mapGetters({
      trainingCourse: 'training/getTrainingCourse',
      trainingTeams: 'educationStudentsManagement/getGroupTrainingTeams'
    }),
    roleOptions() {
      return this.trainingCourse ? this.trainingCourse.roles : []
    },
    options() {
      return this.roleOptions
    }
  },
  watch: {
    trainingTeams: {
      handler() {
        let double = false
        if (this.params.data.role && this.params.data.group) {
          const team = this.trainingTeams.filter((t) => t.id === this.params.data.group)[0]
          if (team) {
            team.roles.forEach((r) => {
              if (r.role === this.params.data.role && r.id !== this.params.data.id) {
                double = true
              }
            })
          }
        }

        this.isDouble = double
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      updateTeams: 'educationStudentsManagement/updateTeams',
      updateStudent: 'educationStudentsManagement/updateStudent'
    }),
    ...mapActions({
      sendMessage: 'socket/sendMessage'
    }),
    onSelectionChange(val) {
      if (this.params.data.group) {
        this.updateTeams({
          team: this.params.data.group,
          role: {
            id: this.params.data.id,
            role: val
          }
        })
      }
      this.sendMessage({
        action: 'trainingRegistrationUpdate',
        data: {
          userId: this.params.data.id,
          role: val,
          group: this.params.data.group
        }
      })
      this.updateStudent({
        id: this.params.data.id,
        role: val,
        group: this.params.data.group
      })
    }
  }
})
